import bem from 'utils/bem';

export const block = bem('self-serve-disco-banner');
